module.exports = __webpack_public_path__ + "static/img/industries14.d6f39f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries14.jpg
// module id = z2Wk
// module chunks = 1